const USER_INFO_KEY = 'userInfo';

export function getUserInfoRaw() {
  try {
    const session = sessionStorage.getItem(USER_INFO_KEY);
    if (session) return session;
  } catch (e) {
    // ignore
  }
  try {
    return localStorage.getItem(USER_INFO_KEY);
  } catch (e) {
    return null;
  }
}

export function getUserInfo() {
  const raw = getUserInfoRaw();
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function isImpersonating() {
  try {
    const sessionRaw = sessionStorage.getItem(USER_INFO_KEY);
    if (!sessionRaw) return false;
    const info = JSON.parse(sessionRaw);
    return !!(info?.isImpersonation || sessionStorage.getItem('isImpersonating') === '1');
  } catch (e) {
    return false;
  }
}

export function setImpersonationUserInfo(userData) {
  const payload = {
    ...userData,
    isImpersonation: true,
  };
  sessionStorage.setItem(USER_INFO_KEY, JSON.stringify(payload));
  sessionStorage.setItem('isImpersonating', '1');
  return payload;
}

export function clearImpersonation() {
  try {
    sessionStorage.removeItem(USER_INFO_KEY);
    sessionStorage.removeItem('isImpersonating');
  } catch (e) {
    // ignore
  }
}

export default {
  getUserInfo,
  getUserInfoRaw,
  isImpersonating,
  setImpersonationUserInfo,
  clearImpersonation,
};
